// GENERATED by scripts/gen-font-metrics.py from arial.ttf / arialbd.ttf — do not edit by hand.
// Horizontal advances in font design units for codepoints 32..255 (index = codepoint - first;
// 0 = no glyph; C1 controls 127..159 are 0) plus a few typographic extras above U+00FF.
export const unitsPerEm = 2048;
export const winAscent = 1854;
export const winDescent = 434;
export const first = 32;
export const regular = [
  569,569,727,1139,1139,1821,1366,391,682,682,797,1196,569,682,569,569,
  1139,1139,1139,1139,1139,1139,1139,1139,1139,1139,569,569,1196,1196,1196,1139,
  2079,1366,1366,1479,1479,1366,1251,1593,1479,569,1024,1366,1139,1706,1479,1593,
  1366,1593,1479,1366,1251,1479,1366,1933,1366,1366,1251,569,569,569,961,1139,
  682,1139,1139,1024,1139,1139,569,1139,1139,455,455,1024,455,1706,1139,1139,
  1139,1139,682,1024,569,1139,1024,1479,1024,1024,1024,684,532,684,1196,0,
  0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
  0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
  569,682,1139,1139,1139,1139,532,1139,682,1509,758,1139,1196,682,1509,1131,
  819,1124,682,682,682,1180,1100,682,682,682,748,1139,1708,1708,1708,1251,
  1366,1366,1366,1366,1366,1366,2048,1479,1366,1366,1366,1366,569,569,569,569,
  1479,1479,1593,1593,1593,1593,1593,1196,1593,1479,1479,1479,1479,1366,1366,1251,
  1139,1139,1139,1139,1139,1139,1821,1024,1139,1139,1139,1139,569,569,569,569,
  1139,1139,1139,1139,1139,1139,1139,1124,1251,1139,1139,1139,1139,1024,1139,1024,
];
export const bold = [
  569,682,971,1139,1139,1821,1479,487,682,682,797,1196,569,682,569,569,
  1139,1139,1139,1139,1139,1139,1139,1139,1139,1139,682,682,1196,1196,1196,1251,
  1997,1479,1479,1479,1479,1366,1251,1593,1479,569,1139,1479,1251,1706,1479,1593,
  1366,1593,1479,1366,1251,1479,1366,1933,1366,1366,1251,682,569,682,1196,1139,
  682,1139,1251,1139,1251,1139,682,1251,1251,569,569,1139,569,1821,1251,1251,
  1251,1251,797,1139,682,1251,1139,1593,1139,1139,1024,797,573,797,1196,0,
  0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
  0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,
  569,682,1139,1139,1139,1139,573,1139,682,1509,758,1139,1196,682,1509,1131,
  819,1124,682,682,682,1180,1139,682,682,682,748,1139,1708,1708,1708,1251,
  1479,1479,1479,1479,1479,1479,2048,1479,1366,1366,1366,1366,569,569,569,569,
  1479,1479,1593,1593,1593,1593,1593,1196,1593,1479,1479,1479,1479,1366,1366,1251,
  1139,1139,1139,1139,1139,1139,1821,1139,1139,1139,1139,1139,569,569,569,569,
  1251,1251,1251,1251,1251,1251,1251,1124,1251,1251,1251,1251,1251,1139,1251,1139,
];
export const extraRegular = { 8211: 1139, 8212: 2048, 8216: 455, 8217: 455, 8220: 682, 8221: 682, 8226: 717, 8230: 2048, 8364: 1139, 8470: 2197, 8482: 2048 };
export const extraBold = { 8211: 1139, 8212: 2048, 8216: 569, 8217: 569, 8220: 1024, 8221: 1024, 8226: 717, 8230: 2048, 8364: 1139, 8470: 2283, 8482: 2048 };
export default { unitsPerEm, winAscent, winDescent, first, regular, bold, extraRegular, extraBold };
